import { useState } from "react";
import SideNavigation from "../components/sideNavigation";
import TopNavigation from "../components/topNavigation";

const MainLayout = ({ children }) => {
  const [isLeftMenuHidden, setIsLeftMenuHidden] = useState(false);
  return (
    <>
      <div className="flexible-content">
        <TopNavigation isLeftMenuHidden={isLeftMenuHidden} />
        <SideNavigation onToggle={() => { setIsLeftMenuHidden(!isLeftMenuHidden) }} />
        <main id="content" className={isLeftMenuHidden ? "wide" : "narrow"} style={{ padding: "15px" }}>
          {children}
        </main>
      </div>
    </>
  );
};

export default MainLayout;
